
import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 'md', className = '' }) => {
  // Adjusted heights to accommodate the full logo (icon + text) aspect ratio
  const logoHeights = {
    sm: 'h-8 md:h-10',
    md: 'h-12 md:h-16',
    lg: 'h-24 md:h-32',
    xl: 'h-40 md:h-56',
    xxl: 'h-64 md:h-[22rem]'
  };
  const src = '/AviaGov.svg';
  const highPriority = size === 'lg' || size === 'xl' || size === 'xxl';

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className={`${logoHeights[size]} relative group`}>
        {/* Reflection / Pedestal Glow */}
        <div className="absolute -bottom-12 left-1/2 -translate-x-1/2 w-3/4 h-24 bg-accent/20 blur-[60px] rounded-full -z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-1000"></div>
        
        {/* Main Logo SVG */}
        <img 
          src={src}
          alt="AviaGov Enterprise Aviation Logo" 
          width={600}
          height={200}
          loading={highPriority ? 'eager' : 'lazy'}
          fetchPriority={highPriority ? 'high' : 'auto'}
          decoding="async"
          className="h-full w-auto object-contain transition-all duration-700 group-hover:scale-105 group-hover:drop-shadow-[0_0_60px_rgba(6,182,212,0.5)] drop-shadow-[0_10px_30px_rgba(0,0,0,0.5)]"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            if (target.src.includes('AviaGov.svg')) {
              target.src = '/logo.svg';
            }
          }}
        />

        {/* Ambient Backlight */}
        <div className="absolute inset-0 bg-accent/5 blur-[100px] rounded-full -z-20 animate-glow-pulse"></div>
      </div>

      <style>{`
        @keyframes glow-pulse {
          0%, 100% { opacity: 0.2; transform: scale(1); }
          50% { opacity: 0.4; transform: scale(1.1); }
        }
        .animate-glow-pulse {
          animation: glow-pulse 6s infinite ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default Logo;
